<template>
  <section>
    <confirm-dialog
      ref="confirmOpen"
      width="450"
      :title="getTitle"
      :showConfirmButton="showConfirmButton"
    >
    </confirm-dialog>
  </section>
</template>

<script>
import ConfirmDialog from '../../../components/Dialogs/ConfirmDialog';
import { getAdminAccount } from '../_api';

import eventBus from '@/Core.Service.Domain/Shared/eventBus.js';

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  props: {
    controlId: { type: Number, required: true },
    controlType: { type: String, required: true },
    siteId: { type: Number, required: true },
  },
  data() {
    return {
      configMenu: false,
      sharedConfigs: [],
      currentConfigId: null,
      initialConfigId: null,
      isLoading: false,
      isSaving: false,
      title: '',
      showConfirmButton: true,
    };
  },
  computed: {
    isDirty() {
      return this.currentConfigId !== this.initialConfigId;
    },
    getTitle() {
      return this.title;
    },
  },

  mounted() {
    this.openConfigDashboard();
  },

  methods: {
    async openConfigDashboard() {
      try {
        eventBus.$emit('isAdminLoading', true);
        this.title = 'Open Control Configuration Page?';
        const data = await getAdminAccount(this.siteId);
        eventBus.$emit('isAdminLoading', false);

        const msgHtml =
          `Will now open Pelican Management Site for the current site, <em>${data.account}</em>, in a new window or tab.` +
          '<br/><br/>' +
          'Please wait for the page to load, then select the <br/>' +
          "<strong style='background: #2988c8; color: white; padding: 4px'><large>Admin Dashboard</large></strong> " +
          'tile (blue background, fourth from the top) to view or configure your configs.';

        const confirmed = await this.$refs.confirmOpen.confirm(msgHtml);

        if (!confirmed) {
          return;
        }

        const windowOptions =
          'modal=yes, toolbar=no, location=no, directories=no, status=no, menubar=no,' +
          'height=800,width=600';

        this.openWindowWithPost(
          data.url,
          windowOptions,
          `dash_config_${data.account}`,
          {
            username: data.user,
            password: data.pass,
          }
        );
      } catch (error) {
        this.showConfirmButton = false;
        this.title = 'Permission Error';
        const msgHtml =
          'You do not have control permission for configuration. Please contact your account or administrator Intech Support to gain access to configuration.';

        this.$refs.confirmOpen.confirm(msgHtml);
        return Promise.reject(error);
      }
    },

    openWindowWithPost(url, windowoption, name, params) {
      var form = document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('action', url);
      form.setAttribute('target', name);
      for (var i in params) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = i;
        input.value = params[i];
        form.appendChild(input);
      }
      document.body.appendChild(form);
      window.open('about:blank', name, windowoption);
      form.submit();
      document.body.removeChild(form);
    },
  },
};
</script>
